import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog/AlertDialog";
import { format } from "date-fns";
import { useSignUp } from "../../hooks/signUp/useSignUp";
import type { Dispatch, SetStateAction } from "react";

const RemoveSignUpDialog = ({
  open,
  onOpenChange,
  data,
  setRotations,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data: {
    rotation: any;
    session: any;
    enrollment?: any;
    preferences?: any;
  };
  setRotations: Dispatch<
    SetStateAction<{
      rotations: any[];
      sessions: any[];
      enrollments: any[];
      preferences: any[];
    }>
  >;
}) => {
  const { removeSignUp, removePreferences } = useSignUp();

  const onRemove = async () => {
    if (data.enrollment) {
      const result = await removeSignUp(data.session._id);
      setRotations((prev) => ({
        ...prev,
        enrollments: prev.enrollments.filter((e) => e._id !== result),
      }));
    } else {
      const result = await removePreferences(data.session._id);
      setRotations((prev) => ({
        ...prev,
        preferences: prev.preferences.filter((p) => p._id !== result),
      }));
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove Enrollment</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you would like to remove{" "}
            {data.session.singleton ? "enrollment" : "preferences"} for{" "}
            {data.session.name} on {format(data.rotation.date, "MMMM dd, yyyy")}
            ?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction variant="destructive" onClick={onRemove}>
            Remove {data.session.singleton ? "Enrollment" : "Preferences"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export { RemoveSignUpDialog };
